import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

type KycRenewalRequiredContext = {
  showKycRenewalRequired: boolean;
  setShowKycRenewalRequired: Dispatch<SetStateAction<boolean>>;
};

export const KycRenewalRequiredContext =
  createContext<KycRenewalRequiredContext | null>(null);

export const useKycRenewalRequiredContext = () =>
  useContext(KycRenewalRequiredContext);
